import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  CheckQuantityInitialStateStateType,
  InboundValidationFormType,
  SetHubFeatureFlagPayloadType,
  SetInboundValidationFormPayloadType,
  StaffManagementType,
} from 'features/SupplyOrder/@types/CheckQuantity'
import { withLoadingReducer } from 'utils/reducerHandler'
import {
  completeSupplyOrderInboundHub,
  completeSupplyOrderInboundProcess,
  deleteSupplyOrderInboundItemDetails,
  fetchAccountInternalFeatureFlagByLocation,
  fetchSupplyOrderInboundHubProcess,
  SLICE_NAME_SO_CHECK_QUANTITY,
  updateSupplyOrderInboundHubPutaway,
  updateSupplyOrderInboundItemDetails,
} from './thunk'

const initialState: CheckQuantityInitialStateStateType = {
  isLoading: false,
  supplyOrderId: -1,
  destinationId: -1,
  originId: -1,
  featureFlags: [],
  flags: {
    productivityTrackerV3: false,
  },
  inboundValidationForm: {
    checker: [],
    expiredDate: null,
    productName: '',
  },
  selectedInventoryController: [],
  supplyOrderInboundHub: {},
}

const generateAssetIdSlice = createSlice({
  name: SLICE_NAME_SO_CHECK_QUANTITY,
  initialState,
  reducers: {
    resetState: () => initialState,
    setInboundValidationForm: (
      state,
      { payload }: PayloadAction<SetInboundValidationFormPayloadType>,
    ) => {
      const { field, value } = payload
      state.inboundValidationForm[field] = value as never
    },
    resetInboundValidationForm: (
      state,
      { payload }: PayloadAction<InboundValidationFormType | undefined>,
    ) => {
      state.inboundValidationForm =
        typeof payload !== 'undefined' ? { ...payload } : initialState.inboundValidationForm
    },
    setSelectedInventoryController: (state, { payload }: PayloadAction<StaffManagementType[]>) => {
      state.selectedInventoryController = payload
    },
    setHubFeatureFlag: (state, { payload }: PayloadAction<SetHubFeatureFlagPayloadType>) => {
      state.flags[payload.field] = payload.value
    },
  },
  extraReducers: withLoadingReducer(
    (builder: ActionReducerMapBuilder<CheckQuantityInitialStateStateType>) => {
      builder.addCase(fetchAccountInternalFeatureFlagByLocation.fulfilled, (state, action) => {
        state.featureFlags = action.payload.hub_feature_flags
      })
      builder.addCase(fetchSupplyOrderInboundHubProcess.fulfilled, (state, action) => {
        const { data } = action.payload

        state.supplyOrderInboundHub = {
          ...data,
        }
        state.supplyOrderId = data.supply_order_id
        state.destinationId = data.destination_location.id
        state.originId = data.origin_location.id
      })
    },
    [
      fetchSupplyOrderInboundHubProcess,
      updateSupplyOrderInboundHubPutaway,
      completeSupplyOrderInboundProcess,
      updateSupplyOrderInboundItemDetails,
      deleteSupplyOrderInboundItemDetails,
      completeSupplyOrderInboundHub,
    ],
  ),
})

export const {
  resetState,
  setInboundValidationForm,
  resetInboundValidationForm,
  setSelectedInventoryController,
  setHubFeatureFlag,
} = generateAssetIdSlice.actions
export default generateAssetIdSlice.reducer
